export default "__VITE_ASSET__28cca4fc__"